/*
  Product gallery thumbnails.
  sections/product-section-2.liquid loads this file. Clicking a thumbnail
  (div.product-img-grid-item) swaps its image into the main product image
  (#main-product-image) and into the zoom popup (.popup-product-img img).
*/
(function () {
  function init() {
    var mainImg = document.getElementById('main-product-image') ||
      document.querySelector('div.featured-product-image img');
    if (!mainImg) return;

    var popupImg = document.querySelector('.popup-product-img img');
    var items = document.querySelectorAll('div.product-img-grid-item');
    if (!items.length) return;

    function copyImage(from, to) {
      var src = from.getAttribute('src');
      if (!src) return;
      to.src = src;
      ['srcset', 'width', 'height'].forEach(function (attr) {
        var value = from.getAttribute(attr);
        if (value) { to.setAttribute(attr, value); } else { to.removeAttribute(attr); }
      });
      if (from.alt) to.alt = from.alt;
    }

    items.forEach(function (item) {
      var thumb = item.querySelector('img');
      if (!thumb) return;
      item.style.cursor = 'pointer';
      item.addEventListener('click', function (event) {
        event.preventDefault();
        copyImage(thumb, mainImg);
        if (popupImg) copyImage(thumb, popupImg);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
